// extracted by mini-css-extract-plugin
module.exports = {"belongRow":"price-table_belongRow__M1iBw","belongTrailingCell":"price-table_belongTrailingCell__yi_bn","belongItemCell":"price-table_belongItemCell__nPc69"};